import React, { useCallback, useRef, useState } from 'react';
import { useDispatch, useMappedState } from 'redux-react-hook';
import _size from 'lodash/size';
import { useAutoFocus } from 'common/customHooks';
import { STRINGS } from 'config';
import { updateFreeTextAnswer } from 'redux/actions/consultation/answer';
import { consultationSelector } from 'redux/selectors/consultation';
import TextField, { CharacterCounter } from 'styles/blocks/textField';
import { NextButton } from '../nextButton';

export function Plain({ isInvalid, isMounted, onClickNextQuestion }) {
  const mapState = useCallback(state => consultationSelector(state), []);
  const { freeTextAnswer, question, inputsReadOnly } = useMappedState(mapState);
  const {
    maxLength,
    text,
    optional,
    questionId,
  } = question;
  const [maxAnswerLength] = useState(maxLength);
  const [isOptional] = useState(optional);
  // Iterate through answer tags incase any indicate that we should have a number, email or phone input box
  const [inputType] = useState(() => {
    const answer = question.answers[0];
    if (answer.tags) {
      if (answer.tags.includes(STRINGS.TAGS.ANSWER.INPUT_TYPE_NUMBER)) {
        return STRINGS.INPUT_TYPES.NUMBER;
      }
      if (answer.tags.includes(STRINGS.TAGS.ANSWER.INPUT_TYPE_EMAIL)) {
        return STRINGS.INPUT_TYPES.EMAIL;
      }
      if (answer.tags.includes(STRINGS.TAGS.ANSWER.INPUT_TYPE_PHONE)) {
        return STRINGS.INPUT_TYPES.PHONE;
      }
    }
    return STRINGS.INPUT_TYPES.TEXT;
  });

  // actions to update value
  const dispatch = useDispatch();

  const [answerText, setAnswerText] = useState(freeTextAnswer);

  const [isCharCountVisible] = useState(!STRINGS.NO_CHARACTER_COUNTER_BY_TAG.some(tag => (question.tags ? question.tags.includes(tag) : false)));

  const updateFreeText = updatedText => {
    setAnswerText(updatedText);
    return dispatch(updateFreeTextAnswer(updatedText));
  };

  const inputRef = useRef();
  useAutoFocus(true, isMounted, inputRef);

  const isNextButtonDisabled = !answerText && !isOptional;
  const answerLength = _size(answerText);

  return (
    <TextField>
      {maxAnswerLength && isCharCountVisible && (
        <CharacterCounter answerLength={answerLength} maxLength={maxLength} id="max-char-label" />
      )}
      <TextField.Input
        type={inputType}
        value={answerText}
        onChange={event => updateFreeText(event.target.value)}
        isInvalid={isInvalid}
        ref={inputRef}
        aria-label={text}
        aria-describedby={maxAnswerLength && isCharCountVisible ? 'max-char-label' : null}
        readOnly={inputsReadOnly}
      />
      <NextButton dataAutomation={`nextButton-${questionId}`} onClick={onClickNextQuestion} isDisabled={isNextButtonDisabled} />
    </TextField>
  );
}
